module.exports = __webpack_public_path__ + "img/audio-ad-preview.52680ea.jpg";